<script setup>
import { formatDateString } from '@/composables/helpers/dates';

const props = defineProps({
    page: {
        type: Object,
        required: false,
    },
});

const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
</script>

<template>
    <div class="blog-headline">
        <div class="category-date">
            <ProjectTag category :link="`/blog?category=${page.data.category.toLowerCase()}`" :text="page.data.category" colorSet="solaris" :useHover="false" :useX="false" gtmEventName="blog_category_tag_clicked" />
            <time :datetime="formatDateString(page.data.datePublished)">{{formatDateString(page.data.datePublished)}}</time>
            <div class="tags">
                <MessLink v-for="(tag, idx) in page.data.tags" :key="idx" :href="'/blog?tags=' + tag" :label="tag">
                    <ProjectTag :text="tag" :useHover="true" capitalize :useX="false" colorSet="meteor-transparent" gtmEventName="blog_tag_clicked" />
                </MessLink>
            </div>
        </div>
        <h1 class="h2">{{ page.data.title }}</h1>
        <div class="tags-share">
            <FragmentsShare :title="page.data.title" />
        </div>
    </div>
</template>

<style lang="scss">

.blog-headline {
    margin: auto;
    max-width: 900px;
    color: var(--teal, #042729);
    margin: 0 auto;
    margin-bottom: 3.25rem;
    margin-top: 3.0625rem;

    h1 {
        font-weight: 500;
        line-height: 4rem;
        letter-spacing: -0.10875rem;
        color: var(--teal);
    }

    .category-date {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        gap: 1.125rem;
        text-transform: uppercase;
        font-weight: 300;
        font-size: 0.8125rem;
        letter-spacing: 0.08125rem;

        time {
            margin-right: 1.125rem;
            font-size: calc(12 / var(--base-fs) * 1rem);
            font-weight: 400;
            line-height: 0.9375rem;
            letter-spacing: 0.0375rem;
            color: var(--teal);
        }

        .tags {
            display: flex;
            gap: 1.125rem;
            flex-direction: row;
            

            .project-tag {
                border: none;
                padding: 0;
                color: var(--teal-gray);
                text-decoration: underline;
                text-underline-offset: 4px;
                font-size: calc(11 / var(--base-fs) * 1rem);

                &:hover {
                    background-color: transparent;
                    color: var(--orange-dark);
                }
            }
        }
    }

    .tags-share {
        display: flex;
        margin-top: 1.75rem;
        color: var(--teal-gray);
    }

    @media (max-width: $tablet) {
        padding-top: 1rem;

        .tags-share {
            flex-wrap: wrap;
            gap: 2rem;

            .tags {
                gap: 1rem;
                flex-wrap: wrap;
                font-size: 10px;

                .fs-12 {
                    font-size: 10px;
                }
            }
        }
    }
}
</style>
